import React, { ReactElement, FC, CSSProperties } from 'react'
import { Typography } from 'antd'
import { s } from './style'

const { Text } = Typography

interface NotStartedStepProps {
  content: string
  style: CSSProperties
}

export const NotStartedStep: FC<NotStartedStepProps> = ({ content, style }): ReactElement => (
  <div style={{ ...style, ...s.root }}>
    <Text style={s.description}>{content}</Text>
  </div>
)
